import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';

const LanguageContext = createContext();

const translations = {
  nav: {
    home: { en: 'Home', ar: 'الرئيسية' },
    about: { en: 'About Guleed Mortgage', ar: 'عن جُليد' },
    services: { en: 'Mortgage Services', ar: 'خدمات التمويل' },
    rates: { en: 'Mortgage Rates', ar: 'أسعار التمويل' },
    contact: { en: 'Contact', ar: 'تواصل معنا' },
    portal: { en: 'Client Portal', ar: 'بوابة العميل' },
    cta: { en: 'Book Free Consultation', ar: 'احجز استشارة مجانية' },
    login: { en: 'Login', ar: 'تسجيل الدخول' },
    register: { en: 'Register', ar: 'إنشاء حساب' },
    logout: { en: 'Logout', ar: 'تسجيل الخروج' },
  },
  hero: {
    h1: { en: 'Your Property. Your Terms. Your Mortgage — Done Right.', ar: 'عقارك. شروطك. تمويلك — بأفضل الحلول' },
    sub: { en: 'Guleed Mortgage helps UAE residents, expats, and overseas investors secure the best mortgage rates from leading banks — fee-free, fast, and fully managed from first call to final approval.', ar: 'جُليد تساعد المقيمين والمغتربين والمستثمرين في الحصول على أفضل معدلات التمويل العقاري من البنوك الرائدة — مجاناً وبسرعة وإدارة كاملة.' },
    cta1: { en: 'Get a Free Consultation', ar: 'احجز استشارة مجانية' },
    cta2: { en: 'Check My Eligibility', ar: 'تحقق من أهليتك' },
  },
  trust: {
    years: { en: 'Years Expertise', ar: 'سنوات خبرة' },
    partners: { en: 'Banking Partners', ar: 'شريك مصرفي' },
    clients: { en: 'Clients Financed', ar: 'عميل تم تمويله' },
    arranged: { en: 'Mortgages Arranged', ar: 'رهن عقاري تم ترتيبه' },
  },
  steps: {
    title: { en: 'How It Works', ar: 'كيف نعمل' },
    s1: { en: 'Qualification Call', ar: 'مكالمة التأهيل' },
    s1d: { en: '20 mins. Tell us your goals.', ar: '20 دقيقة. أخبرنا عن أهدافك.' },
    s2: { en: 'Submit Documents', ar: 'تقديم المستندات' },
    s2d: { en: 'Secure digital upload.', ar: 'رفع رقمي آمن.' },
    s3: { en: 'Bank Pre-Approval', ar: 'الموافقة المبدئية' },
    s3d: { en: 'Within 48 hours.', ar: 'خلال 48 ساعة.' },
    s4: { en: 'Final Approval', ar: 'الموافقة النهائية' },
    s4d: { en: '2–3 weeks to completion.', ar: '2-3 أسابيع للإنجاز.' },
    s5: { en: 'Disbursement', ar: 'صرف التمويل' },
    s5d: { en: 'Your keys. Your property.', ar: 'مفاتيحك. عقارك.' },
  },
  about: {
    title: { en: 'About Guleed Mortgage', ar: 'عن جُليد' },
    story: { en: 'Guleed Mortgage was founded on a simple belief — that accessing the right mortgage shouldn\'t require navigating a maze of banks, paperwork, and conflicting advice alone. From 3 Sails Tower, Corniche, Abu Dhabi, we built Guleed Mortgage to be the advisor we wish everyone had when they first set foot in the UAE real estate market.', ar: 'تأسست جُليد على إيمان بسيط — أن الحصول على التمويل العقاري المناسب لا يجب أن يتطلب التنقل وحيداً في متاهة من البنوك والأوراق والنصائح المتضاربة. من برج 3 أشرعة، الكورنيش، أبوظبي، بنينا جُليد لنكون المستشار الذي يتمناه الجميع.' },
    diff1: { en: 'Fee-Free for You', ar: 'مجاني تماماً للعميل' },
    diff1d: { en: 'Bank pays our fee. You pay zero.', ar: 'البنك يدفع أتعابنا. أنت لا تدفع شيئاً.' },
    diff2: { en: '15+ Banking Partners', ar: 'أكثر من 15 شريك مصرفي' },
    diff2d: { en: 'Access rates not available directly.', ar: 'أسعار غير متاحة مباشرة للعملاء.' },
    diff3: { en: '48-Hour Pre-Approval', ar: 'موافقة مبدئية خلال 48 ساعة' },
    diff3d: { en: 'Fastest in market for qualified clients.', ar: 'الأسرع في السوق للعملاء المؤهلين.' },
    diff4: { en: 'Crypto-to-Property Bridge', ar: 'تحويل العملات الرقمية لعقارات' },
    diff4d: { en: 'Unique service — no UAE competitors.', ar: 'خدمة فريدة — بلا منافسين في الإمارات.' },
    diff5: { en: 'Bilingual Expert Team', ar: 'فريق خبراء ثنائي اللغة' },
    diff5d: { en: 'Arabic + English native advisors.', ar: 'مستشارون عرب وإنجليز.' },
    diff6: { en: 'Remote-Ready Process', ar: 'عملية رقمية كاملة عن بعد' },
    diff6d: { en: 'Non-residents close without UAE visit.', ar: 'غير المقيمين يُنجزون بدون زيارة الإمارات.' },
    partnersTitle: { en: 'Our Banking Partners', ar: 'شركاؤنا المصرفيون' },
  },
  services: {
    title: { en: 'Mortgage Services', ar: 'خدمات التمويل العقاري' },
    tab1: { en: 'First Home Buyer', ar: 'أول عقار' },
    tab2: { en: 'Property Investment', ar: 'عقار استثماري' },
    tab3: { en: 'Non-Resident Mortgage', ar: 'تمويل غير المقيم' },
    tab4: { en: 'Refinance & Equity', ar: 'إعادة التمويل' },
    tab6: { en: 'Commercial Property', ar: 'العقار التجاري' },
  },
  rates: {
    title: { en: 'Mortgage Rates', ar: 'أسعار التمويل العقاري' },
    resident: { en: 'Resident Rates', ar: 'أسعار المقيمين' },
    nonResident: { en: 'Non-Resident Rates', ar: 'أسعار غير المقيمين' },
    calcTitle: { en: 'Mortgage Calculator', ar: 'حاسبة التمويل العقاري' },
    product: { en: 'Product', ar: 'المنتج' },
    rateType: { en: 'Rate Type', ar: 'نوع السعر' },
    bestRate: { en: 'Best Rate', ar: 'أفضل سعر' },
    notes: { en: 'Notes', ar: 'ملاحظات' },
    propertyPrice: { en: 'Property Price (AED)', ar: 'سعر العقار (درهم)' },
    downPayment: { en: 'Down Payment %', ar: 'الدفعة المقدمة %' },
    rate: { en: 'Interest Rate %', ar: 'معدل الفائدة %' },
    tenure: { en: 'Tenure (Years)', ar: 'المدة (سنوات)' },
    monthly: { en: 'Monthly Payment', ar: 'القسط الشهري' },
    totalInterest: { en: 'Total Interest', ar: 'إجمالي الفوائد' },
    totalCost: { en: 'Total Cost', ar: 'التكلفة الإجمالية' },
    ltv: { en: 'Loan-to-Value', ar: 'نسبة القرض للقيمة' },
  },
  contact: {
    title: { en: 'Contact Us', ar: 'تواصل معنا' },
    sub: { en: 'Get in touch with our mortgage experts', ar: 'تواصل مع خبراء التمويل العقاري لدينا' },
    name: { en: 'Full Name', ar: 'الاسم الكامل' },
    email: { en: 'Email', ar: 'البريد الإلكتروني' },
    phone: { en: 'Phone', ar: 'الهاتف' },
    subject: { en: 'Subject', ar: 'الموضوع' },
    message: { en: 'Message', ar: 'الرسالة' },
    send: { en: 'Send Message', ar: 'إرسال الرسالة' },
    address: { en: '3 Sails Tower, Corniche, Abu Dhabi, UAE', ar: 'برج 3 أشرعة، الكورنيش، أبوظبي، الإمارات' },
  },
  portal: {
    title: { en: 'Client Portal', ar: 'بوابة العميل' },
    dashboard: { en: 'Dashboard', ar: 'لوحة التحكم' },
    documents: { en: 'Documents', ar: 'المستندات' },
    progress: { en: 'Progress', ar: 'التقدم' },
    upload: { en: 'Upload Document', ar: 'رفع مستند' },
    status: { en: 'Application Status', ar: 'حالة الطلب' },
    welcome: { en: 'Welcome back', ar: 'مرحباً بعودتك' },
  },
  lead: {
    title: { en: 'Get Your Free Mortgage Assessment in 2 Minutes', ar: 'احصل على تقييم مجاني للتمويل العقاري في دقيقتين' },
    fullName: { en: 'Full Name', ar: 'الاسم الكامل' },
    phone: { en: 'Phone (WhatsApp preferred)', ar: 'الهاتف (واتساب مفضل)' },
    enquiryType: { en: 'Enquiry Type', ar: 'نوع الاستفسار' },
    submit: { en: 'Get My Free Assessment', ar: 'احصل على التقييم المجاني' },
  },
  testimonials: {
    title: { en: 'What Our Clients Say', ar: 'ماذا يقول عملاؤنا' },
  },
  footer: {
    rights: { en: '© 2025 Guleed Mortgages Real Estate LLC. All rights reserved.', ar: '© 2025 جُليد للرهن العقاري. جميع الحقوق محفوظة.' },
    tagline: { en: 'For Mortgage and Financial Advisory Services', ar: 'للاستشارات المالية والرهن العقاري' },
  },
  common: {
    learnMore: { en: 'Learn More', ar: 'اعرف المزيد' },
    getStarted: { en: 'Get Started', ar: 'ابدأ الآن' },
    success: { en: 'Success!', ar: 'نجاح!' },
    error: { en: 'Error', ar: 'خطأ' },
  },
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState('en');

  const toggleLang = useCallback(() => {
    setLang(prev => prev === 'en' ? 'ar' : 'en');
  }, []);

  const t = useCallback((section, key) => {
    return translations[section]?.[key]?.[lang] || key;
  }, [lang]);

  useEffect(() => {
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
    document.body.dir = lang === 'ar' ? 'rtl' : 'ltr';
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, toggleLang, t, isRTL: lang === 'ar' }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be inside LanguageProvider');
  return ctx;
}
